// src/components/WhatsAppWidget.tsx
import React from "react";

const WhatsAppWidget: React.FC = () => {
  const phoneNumber = process.env.REACT_APP_WHATSAPP_NUMBER;
  const defaultMessage = process.env.REACT_APP_WHATSAPP_MESSAGE;

  if (!phoneNumber) {
    console.warn("WhatsApp number not defined in .env");
    return null;
  }

  const link = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage || "")}`;

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "20px",
        left: "20px",
        backgroundColor: "#25D366",
        color: "#fff",
        borderRadius: "50px",
        padding: "10px 15px",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontWeight: 500,
        textDecoration: "none",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        zIndex: 1000,
        cursor: "pointer",
        transition: "transform 0.2s ease-in-out",
      }}
      aria-label="Chat on WhatsApp"
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      {/* Inline WhatsApp SVG */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="white"
        viewBox="0 0 24 24"
      >
        <path d="M20.52 3.48A11.92 11.92 0 0012 .08C5.37.08.08 5.37.08 12a11.86 11.86 0 001.7 6.01L0 24l6.05-1.69a11.86 11.86 0 006.01 1.7c6.63 0 11.92-5.29 11.92-11.92 0-3.18-1.24-6.16-3.48-8.61zM12 21a9 9 0 01-4.52-1.23l-.32-.19-3.59 1 1-3.51-.21-.35A9 9 0 1112 21zm5.05-7.9l-1.56.46a.59.59 0 00-.27.1.61.61 0 00-.24.22l-.57 1.1a6.5 6.5 0 01-2.93-2.93l1.1-.57a.61.61 0 00.22-.24.59.59 0 00.1-.27l.46-1.56a.6.6 0 00-.57-.76h-1.64a.6.6 0 00-.6.6v1.64a.6.6 0 00.76.57l1.56-.46a4.01 4.01 0 003.28 3.28z"/>
      </svg>
      <span>Chat with us</span>
    </a>
  );
};

export default WhatsAppWidget;
